module.exports = __webpack_public_path__ + "assets/img/02-m.9b0d1e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/02-m.jpg
// module id = MlFu
// module chunks = 0